import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IvyCarouselModule } from 'angular-responsive-carousel';
import { CategoryContainerComponent } from './components/category-container/category-container.component';
import { BenefitDialogComponent } from './components/dialogs/benefit-dialog/benefit-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
    declarations: [CategoryContainerComponent, BenefitDialogComponent],
    exports: [CategoryContainerComponent],
    imports: [
        CommonModule,
        IvyCarouselModule,
        MatDialogModule,
    ]
})
export class SharedModule { }
